import storefront from "../../global/storefront";
import generateGroupsQuery from "./generateGroupsQuery";
import generateCacheName from "../generateCacheName";
import {
  normalizeGroupValue,
  isVisibleStorefrontProduct,
} from "../unwrapProducts";
import addProductHelpers from "../addProductHelpers";

const BATCHING_DELAY = 100;

const groupsCache = {};
let groupsQueue = [];
let timeout = null;

export default function fetchGroup(name) {
  const cacheName = generateCacheName(name);

  if (cacheName in groupsCache) return Promise.resolve(groupsCache[cacheName]);

  let resolveGroupData;
  const groupData = new Promise((resolve) => {
    resolveGroupData = resolve;
  });

  const newGroupQueueItem = {
    name,
    resolve: resolveGroupData,
  };

  groupsQueue.push(newGroupQueueItem);

  if (timeout === null) {
    timeout = setTimeout(() => {
      timeout = null;

      const groupsToFetch = groupsQueue;

      groupsQueue = [];

      storefront
        .request({
          query: generateGroupsQuery(groupsToFetch),
        })
        .then((response) => {
          const data = response?.data || {};

          // Add data to cache, merging in any Purple Dot product family references
          for (const [key, value] of Object.entries(data)) {
            groupsCache[key] = normalizeGroupValue(value)
              .filter(isVisibleStorefrontProduct)
              .map(addProductHelpers);
          }
          console.log("groupsCache", groupsCache);
          // Resolve pending promises with data
          groupsToFetch.forEach((group) => {
            const cacheName = generateCacheName(group.name);

            group.resolve(groupsCache[cacheName] || []);
          });
        })
        .catch((error) => {
          console.error("Error fetching product group", error);
          groupsToFetch.forEach((group) => group.resolve([]));
        });
    }, BATCHING_DELAY);
  }

  return groupData;
}
